// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kIGQ","left":"styles_left__2senm","desktopActions":"styles_desktopActions__2BHdP","title":"styles_title__3SxRy"};